export default __webpack_public_path__ + "static/media/send_drink.81f4f8a0.png";